import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Controller } from "react-hook-form";
import { IsDesktopHandler } from "../../../helpers";
import errorMessage from "../../../common/errorMessages.json";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import FormHelperText from "@mui/material/FormHelperText";

const useStyles = makeStyles((theme) => ({
  inputContainerStyleHorizontal: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  inputContainerStyleVertical: {
    "& label": {
      fontSize: "14px",
      color: "#4C5662 !important",
    },
    "& input": {
      fontSize: "15px",
      color: theme.palette.text.primary.main,
    },
    "& fieldset": {
      "& legend": {
        fontSize: "12px",
      },
    },
  },
  listBox: {
    fontSize: "14px",
    color: theme.palette.text.primary.main,
  },
  labelDesktopStyle: {
    fontSize: "0.85rem",
    fontWeight: 400,
    width: 180,
    wordWrap: "break-word",
    boxSizing: "border-box",
    flexShrink: 0,
    marginRight: 12,
  },
  errorText: {
    marginTop: theme.spacing(0.5),
    fontSize: "0.75rem",
    color: theme.palette.error.main,
  },
}));

const AutoCompleteFreeSoloController = ({
  control,
  data = [],
  dataOptionLabel = "label",
  labeltext,
  errors,
  require = false,
  name,
  defaultValue = "",
  loadingComboState = false,
  placeholder = "",
  display = "horizontal",
  minheight = true,
  sizeSelect = null,
  containerStyle = {},
  style = {},
  ...props
}) => {
  const [stateMessage, setStateMessage] = useState("");
  const [stateError, setStateError] = useState(false);
  const classesUI = useStyles();

  useEffect(() => {
    if (errors) {
      switch (errors.type) {
        case "required":
          setStateMessage(
            errorMessage.message[errors.ref.name]?.required ||
              errorMessage.message[errors.ref.name]
          );
          break;
        default:
          break;
      }
      setStateError(true);
    } else {
      setStateMessage("");
      setStateError(false);
    }
  }, [errors]);

  let labelText = null;
  const isDesktop = IsDesktopHandler("sm");
  if (!isDesktop) {
    labelText = labeltext;
  } else {
    labelText = null;
  }
  if (display === "vertical") {
    labelText = labeltext;
  }

  return (
    <div
      className={clsx(
        display === "horizontal"
          ? classesUI.inputContainerStyleHorizontal
          : classesUI.inputContainerStyleVertical
      )}
    >
      {display === "horizontal" ? (
        <div className={classesUI.labelDesktopStyle}>{labeltext}</div>
      ) : null}
      {loadingComboState && <p>cargando</p>}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={{ required: require }}
        render={({ field: { onChange, value, ...fieldProps } }) => (
          <Autocomplete
            freeSolo
            options={data.map((option) =>
              typeof option === "string"
                ? option
                : option[dataOptionLabel] || option.label || ""
            )}
            value={value || ""}
            loading={loadingComboState}
            onInputChange={(e, newValue) => onChange(newValue)}
            ListboxProps={{ className: classesUI.listBox }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={labelText}
                variant="outlined"
                margin="dense"
                fullWidth
                error={stateError}
                placeholder={placeholder}
                // El resto de los estilos los toma del theme global y del layout
              />
            )}
            {...props}
          />
        )}
      />
      {stateError && (
        <FormHelperText className={classesUI.errorText} error>
          {stateMessage}
        </FormHelperText>
      )}
    </div>
  );
};

export default AutoCompleteFreeSoloController;
